import { render, staticRenderFns } from "./ErrorsOverLastWeekChart.vue?vue&type=template&id=7630da72&"
import script from "./ErrorsOverLastWeekChart.vue?vue&type=script&lang=js&"
export * from "./ErrorsOverLastWeekChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports